/* eslint-disable max-len */

import React from 'react';
import { IIconProps } from './utils';

interface CircleProps extends IIconProps {
  size?: number;
}

export const Circle = ({ color, size = 9, ...rest }: CircleProps) => (
  <svg
    height={size}
    viewBox={`0 0 ${size} ${size}`}
    width={size}
    {...rest}
  >
    <circle
      cx={size / 2}
      cy={size / 2}
      fill={color}
      r={size / 2}
    />
  </svg>
);
